import { useContext, useEffect, useState } from "react";
import mostPopular from "../Images/blupricing.svg";
import skyBlueMostPopular from "../Images/sky_blue_popular.svg";
import net from "../Images/ImageToStl.com_web.avif";
import { useRef } from "react";
import { read, utils } from "xlsx";
import axios from "axios";
import BaseUrl from "../BaseUrl";
import { ToastContainer, toast } from "react-toastify";
import { Helmet } from "react-helmet";
import CircularProgress from "@mui/material/CircularProgress";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import "react-toastify/dist/ReactToastify.css";
import Backdrop from "@mui/material/Backdrop";
import Modal from "@mui/material/Modal";
import { Box, Fade } from "@mui/material";
import { MenuItem, TextField } from "@mui/material";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import logo from "../Images/logo.png";
import Context from "../Contex/Context";
import { loadScript } from "@paypal/paypal-js";
import oneTimepaymentImage from "../Images/Wallet-rafiki.svg";
import paypalImage from "../Images/paypal-icon.svg";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import { initializePaddle, Paddle } from "@paddle/paddle-js";
const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 500,
  bgcolor: "background.paper",
  borderRadius: "7px",
  boxShadow: 24,
  p: 2,
  zIndex: 200,
};
const style2 = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 600,
  bgcolor: "background.paper",
  borderRadius: "7px",
  boxShadow: 24,
  p: 2,
  zIndex: 200,
};
const firstGrid = [
  "Custom Email Verifier",
  "Custom Email Warm-up",
  "Custom Drip Campaigns",
  "Custom Email CRM",
  "Custom campaigns",
];
const secondGrid = [
  "Custom Email Warmup",
  "Custom Calendly integration",
  "Custom A/BTesting",
  "Custom Sender Rotation",
];
const PricingObject = [
  {
    _id: "66543986fca069ccff647948",
    Name: "Free",
    Description: "Ideal to try out",
    priceList: [
      {
        PriceUnit: "INR",
        Price: 0,
        symbol: "₹",
        id: "65b385d477fb810a5bab308a",
      },
      {
        PriceUnit: "USD",
        Price: 0,
        symbol: "$",
        id: "65b385d477fb810a5bab308a",
      },
      {
        PriceUnit: "EUR",
        Price: 0,
        symbol: "€",
        id: "65b385d477fb810a5bab308a",
      },
    ],
    PriceUnit: "Dollar",
    Price: 0,
    Days: 30,
    EmailDrip: 1,
    EmailSenderAccount: -9999,
    ContactLimit: 100,
    EmailLimit: 100,
    EmailWarmUpLimit: 0,
    EmailVerificationLimit: 0,
    TeamMemberLimit: 0,
    EmailAIAssistant: true,
    ABTesting: true,
    EmailCRM: true,
    SenderRotation: true,
    CalendlyIntegration: true,
    Status: true,
    createdAt: "2023-11-30T07:14:52.829Z",
    updatedAt: "2023-11-30T07:14:52.829Z",
    __v: 0,
    id: 1,
    title: "$0",
    ChargebeePlanId: "Trail-Plan-0001-USD-Monthly",
    feats: [
      {
        id: 1,
        title: "Free",
        points: [
          "100 emails per month",
          "100 email recipients",
          "Unlimited sender accounts",
          "20 Email verification",
          "1 Drip campaign",
          "1 Email Warmup",
        ],
      },
      {
        id: 2,
        title: "Everything in Free, plus:",
        points: [
          "Email Verifier",
          "Drip Campaigns",
          "Email Warmup",
          "Calendly",
        ],
      },
    ],
  },
  {
    id: 2,
    _id: "656837e3625efe475c46c0df",
    Name: "Standard",
    Description: "All the core tools needed to set up steady sales",
    priceListPayPal: [
      {
        planId: "P-7KJ32778XU804351AMXKEHMY",
        PriceUnit: "USD",
      },
      {
        planId: "P-62090676R5434544VMXKEBCY",
        PriceUnit: "EUR",
      },
    ],
    priceList: [
      {
        PriceUnit: "INR",
        Price: 4090,
        symbol: "₹",
        id: "pri_01hrwh7eyspvqjsjzxssqjag5v",
      },
      {
        PriceUnit: "USD",
        Price: 49,
        symbol: "$",
        id: "pri_01hrwh7eyspvqjsjzxssqjag5v",
      },
      {
        PriceUnit: "EUR",
        Price: 46,
        symbol: "€",
        id: "pri_01hrwh7eyspvqjsjzxssqjag5v",
      },
    ],
    PriceUnit: "Dollar",
    Price: 15,
    Days: 30,
    ChargebeePlanId: "Standard-Plan-USD-Monthly",
    EmailDrip: -9999,
    EmailSenderAccount: -9999,
    ContactLimit: 100000,
    EmailLimit: 6000,
    EmailWarmUpLimit: -9999,
    EmailVerificationLimit: 1000,
    TeamMemberLimit: -9999,
    EmailAIAssistant: true,
    ABTesting: true,
    EmailCRM: true,
    SenderRotation: true,
    CalendlyIntegration: true,
    Status: true,
    createdAt: "2023-11-30T07:21:07.934Z",
    updatedAt: "2023-11-30T07:21:07.934Z",
    __v: 0,
    title: "$15",
    discountPrice: "$29",
    feats: [
      {
        id: 1,
        title: "Standard",
        points: [
          "6000 Emails per month",
          "100000 email recipients",
          "Unlimited sender accounts",
          "1000 Additional email verification",
          "Unlimited Drip campaign",
          "Unlimited Email Warmup",
          "Unlimited Team members",
        ],
      },
      {
        id: 3,
        title: "Everything in Standard, plus:",
        points: [
          "Email Verifier",
          "Email Warm-up",
          "Drip Campaigns",
          "Email CRM",
          "Unlimited campaigns",
          "Unlimited Email Warmup",
          "Calendly integration",
          "A/BTesting",
          "Sender Rotation",
        ],
      },
    ],
  },
  {
    _id: "6568391a625efe475c46c51f",
    Name: "Professional",
    Description:
      "Professional choice for unlimited sales and business opportunities.",
    priceListPayPal: [
      {
        planId: "P-6B209958CT763083EMXG2FRQ",
        PriceUnit: "USD",
      },
      {
        planId: "P-8CK333260B474960GMXKEI6I",
        PriceUnit: "EUR",
      },
    ],
    priceList: [
      {
        PriceUnit: "INR",
        Price: 8264,
        symbol: "₹",
        id: "pri_01hsbajre9r02fq2myzvnqcx6z",
      },
      {
        PriceUnit: "USD",
        Price: 99,
        symbol: "$",
        id: "pri_01hsbajre9r02fq2myzvnqcx6z",
      },
      {
        PriceUnit: "EUR",
        Price: 92,
        symbol: "€",
        id: "pri_01hsbajre9r02fq2myzvnqcx6z",
      },
    ],
    PriceUnit: "Dollar",
    Price: 30,
    Days: 30,
    ChargebeePlanId: "Premium-Plan-USD-Monthly",
    EmailDrip: -9999,
    EmailSenderAccount: -9999,
    ContactLimit: 100000,
    EmailLimit: 50000,
    EmailWarmUpLimit: -9999,
    EmailVerificationLimit: 1000,
    TeamMemberLimit: -9999,
    EmailAIAssistant: true,
    ABTesting: true,
    EmailCRM: true,
    SenderRotation: true,
    CalendlyIntegration: true,
    Status: true,
    createdAt: "2023-11-30T07:26:18.574Z",
    updatedAt: "2023-11-30T07:26:18.574Z",
    __v: 0,
    id: 3,
    title: "$29",
    discountPrice: "$59",
    feats: [
      {
        id: 1,
        title: "Professional",
        points: [
          "50000 emails per month",
          "100000 email recipients",
          "Unlimited sender accounts",
          "5000 Additional Email verification",
          "Unlimited Drip campaign",
          "Unlimited Email Warmup",
          "Unlimited Team members",
        ],
      },
      {
        id: 2,
        title: "Everything in Professional, plus:",
        points: [
          "Email Verifier",
          "Email Warm-up",
          "Drip Campaigns",
          "Email CRM",
          "Unlimited campaigns",
          "Unlimited Email Warmup",
          "Calendly integration",
          "A/BTesting",
          "Sender Rotation",
        ],
      },
    ],
  },
  {
    _id: "65683b1c625efe475c46cd86",
    Name: "Ultimate",
    Description:
      "Ultimate choice for unlimited sales and business opportunities.",
    priceListPayPal: [
      {
        planId: "P-1C4390818D364533HMXKEH4I",
        PriceUnit: "USD",
      },
      {
        planId: "P-96L44895CU7274112MXKEJOA",
        PriceUnit: "EUR",
      },
    ],
    priceList: [
      {
        PriceUnit: "INR",
        Price: 83395,
        symbol: "₹",
        id: "pri_01hsbadzbabp72r7499qqnysmd",
      },
      {
        PriceUnit: "USD",
        Price: 999,
        symbol: "$",
        id: "pri_01hsbadzbabp72r7499qqnysmd",
      },
      {
        PriceUnit: "EUR",
        Price: 933,
        symbol: "€",
        id: "pri_01hsbadzbabp72r7499qqnysmd",
      },
    ],
    PriceUnit: "Dollar",
    Price: 599,
    Days: 365,
    ChargebeePlanId: "Ultimate-Plan-USD-Yearly",
    EmailDrip: -9999,
    EmailSenderAccount: -9999,
    ContactLimit: 50000,
    EmailLimit: 200000,
    EmailWarmUpLimit: -9999,
    EmailVerificationLimit: 20000,
    TeamMemberLimit: -9999,
    EmailAIAssistant: true,
    ABTesting: true,
    EmailCRM: true,
    SenderRotation: true,
    CalendlyIntegration: true,
    Status: true,
    createdAt: "2023-11-30T07:34:52.034Z",
    updatedAt: "2023-11-30T07:34:52.034Z",
    __v: 0,
    id: 4,
    title: "$125",
    discountPrice: "$180",
    feats: [
      {
        id: 1,
        title: "Standard",
        points: [
          "6000 emails per year",
          "100000 email recipients",
          "Unlimited sender accounts",
          "1000 Additional Email verification",
          "Unlimited Drip campaign",
          "Unlimited Email Warmup",
          "Unlimited Team members",
        ],
      },
      {
        id: 2,
        title: "Everything in Standard, plus:",
        points: [
          "Email Verifier",
          "Email Warm-up",
          "Drip Campaigns",
          "Email CRM",
          "Unlimited campaigns",
          "Unlimited Email Warmup",
          "Calendly integration",
          "A/BTesting",
          "Sender Rotation",
        ],
      },
    ],
  },
  {
    _id: "65683c01625efe475c46d1cd",
    Name: "Enterprise",
    Description:
      "Enterprise choice for unlimited sales and business opportunities.",
    priceListPayPal: [
      {
        planId: "P-26H965898X345573KMXKEIKA",
        PriceUnit: "USD",
      },
      {
        planId: "P-5AC45596LS434053RMXKEJ3A",
        PriceUnit: "EUR",
      },
    ],
    priceList: [
      {
        PriceUnit: "INR",
        Price: 41656,
        symbol: "₹",
        id: "pri_01hsbap8dd340j225ff7ymwgpp",
      },
      {
        PriceUnit: "USD",
        Price: 499,
        symbol: "$",
        id: "pri_01hsbap8dd340j225ff7ymwgpp",
      },
      {
        PriceUnit: "EUR",
        Price: 466,
        symbol: "€",
        id: "pri_01hsbap8dd340j225ff7ymwgpp",
      },
    ],
    PriceUnit: "Dollar",
    Price: 349,
    Days: 365,
    ChargebeePlanId: "Essential-Plan-USD-Yearly",
    EmailDrip: -9999,
    EmailSenderAccount: -9999,
    ContactLimit: 100000,
    EmailLimit: 6000,
    EmailWarmUpLimit: -9999,
    EmailVerificationLimit: 1000,
    TeamMemberLimit: -9999,
    EmailAIAssistant: true,
    ABTesting: true,
    EmailCRM: true,
    SenderRotation: true,
    CalendlyIntegration: true,
    Status: true,
    createdAt: "2023-11-30T07:38:41.701Z",
    updatedAt: "2023-11-30T07:38:41.701Z",
    __v: 0,
    id: 5,
    title: "$269",
    discountPrice: "$300",
    feats: [
      {
        id: 1,
        title: "Professional",
        points: [
          "50000 emails per year",
          "100000 email recipients",
          "Unlimited sender accounts",
          "5000 Additional Email verification",
          "Unlimited Drip campaign",
          "Unlimited Email Warmup",
          "Unlimited Team members",
        ],
      },
      {
        id: 2,
        title: "Everything in Professional, plus:",
        points: [
          "Email Verifier",
          "Email Warm-up",
          "Drip Campaigns",
          "Email CRM",
          "Unlimited campaigns",
          "Unlimited Email Warmup",
          "Calendly integration",
          "A/BTesting",
          "Sender Rotation",
        ],
      },
    ],
  },
];

const Pricing = () => {
  const { currentPlan } = useContext(Context);
  console.log("currentplan", currentPlan);
  const userDetails = JSON.parse(localStorage.getItem("MailSenderuserDetails"));
  const [activePlan, setActivePlan] = useState(1);
  const [data, setData] = useState(PricingObject);
  const [activeBtn, setActiveBtn] = useState("emailMarketing");
  const [billing, setBilling] = useState([]);
  const [activeText, setActiveText] = useState("MONTHLY");
  const [inActiveBorder, setInActiveBorder] = useState("transparent");
  // const [newItem, setNewItem] = useState(currentPlan.length===0);
  const [showToast, setShowToast] = useState(false);
  const [loader, setLoader] = useState(false);
  // const [allPlans, setAllPlans] = useState([]);
  const [priceType, setPriceType] = useState("USD");
  const [open, setOpen] = useState(false);
  const [planId, setPlanId] = useState("");
  const [selectedPlan, setSelectedPlan] = useState("");
  const [paymentType, setPaymentType] = useState("One Time");
  const [paddle, setPaddle] = useState(null);
  useEffect(() => {
    initializePaddle({ token: "test_447f4a38a3fb451ad06e88f93f9" }).then(
      (paddleInstance) => {
        if (paddleInstance) {
          paddleInstance.Environment.set('sandbox');
          setPaddle(paddleInstance);
        }
      }
    );
  }, []);

  // const liHeights = useRef([]);
  // const calculateLiHeights = () => {
  //   liHeights.current = data.map(() => ({
  //     height: 0,
  //   }));
  // };

  // useEffect(() => {
  //   calculateLiHeights();
  // }, [data,activePlan]);

  // useEffect(() => {
  //     liHeights.current.forEach((li, index) => {
  //       const liElement = document.getElementById(`li-${index}`);
  //       if (liElement) {
  //         li.height = liElement.clientHeight;
  //       }
  //     });
  //   }, [data, activePlan]);
  // useEffect(() => {
  //   getUserCurrentPlan();
  // }, []);
  // function getUserCurrentPlan() {
  //   axios
  //     .get(
  //       `${BaseUrl.baseurl}/email-marketing/user/get-user-current-plan/${
  //         userDetails && userDetails.details._id
  //       }`,
  //       {
  //         headers: {
  //           Authorization: `Bearear ${userDetails && userDetails.token}`,
  //         },
  //       }
  //     )
  //     .then((response) => {
  //       if (response.data.status) {

  //         setNewItem(false)
  //         setAllPlans(response.data);
  //       } else {
  //         setNewItem(true)
  //         setAllPlans([]);
  //         if (response.data.tokenExpire) {
  //           localStorage.removeItem("MailSenderuserDetails");
  //           window.location.reload();
  //         }
  //       }
  //     })
  //     .catch((err) => console.log("Error"));
  // }
  // function getBillingDetails() {
  //   axios
  //     .get(
  //       `${
  //         BaseUrl.baseurl
  //       }/email-marketing/user/get-user-chargebee-subscription/${
  //         userDetails && userDetails.details._id
  //       }`,
  //       {
  //         headers: {
  //           Authorization: `Bearear ${userDetails && userDetails.token}`,
  //         },
  //       }
  //     )
  //     .then((response) => {
  //       if (response.data.status) {
  //         setBilling(response.data.details);
  //         setLoader(false);
  //         if(response.data.details.list.length===0){
  //           setNewItem(true)
  //         }
  //         else
  //         {
  //           setNewItem(false)
  //         }
  //       } else {
  //         setBilling([]);
  //         setLoader(false);
  //         if (response.data.tokenExpire) {
  //           localStorage.removeItem("MailSenderuserDetails");
  //           window.location.reload();
  //         }
  //       }
  //     })
  //     .catch((err) => console.log("Error"));
  // }
  // useEffect(() => {
  //   getBillingDetails();
  // }, []);
  function callPricingFunction(planId, paymentDetails, paymenttype, recursion) {
    let priceData = {
      paymentDetails: paymentDetails,
      paymentType: paymenttype,
      paymenyRecursion: recursion,
    };
    let config = {
      method: "post",
      maxBodyLength: Infinity,
      url: `${BaseUrl.baseurl}/email-marketing/user/user-payment/${
        userDetails && userDetails.details._id
      }/${planId}`,
      priceData,
      headers: {
        Authorization: `Bearear ${userDetails && userDetails.token}`,
      },
    };

    axios
      .request(config)
      .then((response) => {
        console.log("results", response.data);
        window.location.reload();
      })
      .catch((error) => {
        console.log(error);
      });
  }
  const handleSubscribeClick = async (price, priceUnit, id) => {
    let data = {
      amount: price,
      currency: priceUnit,
    };
    let config = {
      method: "post",
      maxBodyLength: Infinity,
      url: `${
        BaseUrl.baseurl
      }/email-marketing/user/get-user-payment-order-details/${
        userDetails && userDetails.details._id
      }`,
      headers: {
        Authorization: `Bearear ${userDetails && userDetails.token}`,
      },
      data: data,
    };
    axios
      .request(config)
      .then((response) => {
        var options = {
          key: "rzp_live_fChJFRfAnYJos9", // Enter the Key ID generated from the Dashboard
          amount: price * 100, // Amount is in currency subunits. Default currency is INR. Hence, 50000 refers to 50000 paise
          currency: priceUnit,
          name: "Cold Sender", //your business name
          description: "email marketting tool",
          image: logo,
          order_id: response.data.details.id, //This is a sample Order ID. Pass the `id` obtained in the response of Step 1
          handler: function (response) {
            callPricingFunction(id, response, "Razor pay", false);
            // alert(response.razorpay_payment_id);
            // alert(response.razorpay_order_id);
            // alert(response.razorpay_signature)
          },
          prefill: {
            //We recommend using the prefill parameter to auto-fill customer's contact information, especially their phone number
            name: userDetails && userDetails.details.FirstName, //your customer's name
            email: userDetails && userDetails.details.Email,
            ...(priceUnit !== "INR" && { contact: "9292929929" }),
          },

          theme: {
            color: "#1c485f",
          },
          modal: {
            ondismiss: function () {
              setLoader(false);
              toast.error("Payment failed !! please try again closed");
              setPaymentData({});
            },
          },
        };
        // eslint-disable-next-line no-undef
        var rzp1 = new Razorpay(options);
        rzp1.on("payment.failed", function (response) {
          setLoader(false);
          console.log("payment failed");
          toast.error("Payment failed !! please try again");

        });
        // rzp1.open();
        paddle &&
          paddle.Checkout.open({
            items: [{ priceId: id, quantity: 1 }],
          });
      })
      .catch((error) => {
        console.log(error);
      });
    // if(newItem){
    //   let subData = {
    //     priceId: planId,
    //     customerId: userDetails.details.ChargeBeeId,
    //     email: userDetails.details.Email,
    //     fName: userDetails.details.FirstName,
    //     lName: userDetails.details.LastName,
    //   };
    //   axios
    //     .post(
    //       `${BaseUrl.baseurl}/email-marketing/user/create-user-subscription`,
    //       subData,
    //       {
    //         headers: {
    //           Authorization: `Bearer ${userDetails && userDetails.token}`,
    //         },
    //       }
    //     )
    //     .then((response) => {
    //       if (response.data.status) {
    //         setLoader(false);
    //         const cbInstance = window.Chargebee.init({
    //           site: "digitalads",
    //           domain: "https://app.coldsender.com",
    //         });

    //         cbInstance.openCheckout({
    //           hostedPage: function () {
    //             return new Promise(function (resolve, reject) {
    //               resolve(response.data.details);
    //             });
    //           },
    //           success: function (hostedPageId) {

    //             setTimeout(()=>{
    //               callPricingFunction()
    //             },500)
    //             console.log("dndndndnd", hostedPageId);
    //           },
    //           error: (error) => {
    //             setTimeout(()=>{
    //               callPricingFunction()
    //             },500)
    //             setShowToast(true);
    //             toast.error("Payment failed", {
    //               autoClose: true,
    //               position: "top-right",
    //               duration: 3000,
    //             });
    //           },
    //         });
    //       } else {
    //         toast.error(response.data.message, {
    //           autoClose: true,
    //           position: "top-right",
    //           duration: 3000,
    //         });
    //         setLoader(false);
    //         if (response.data.tokenExpire) {
    //           localStorage.removeItem("MailSenderuserDetails");
    //           window.location.reload();
    //         }
    //       }
    //     })
    //     .catch((error) => {
    //       console.error("Error:", error);
    //     });
    // }
    // else
    // {
    //   let updateData={
    //     subscriptionId:billing?.list[0]?.subscription.id,
    //     priceId:planId,
    //     unitPrice:price*100
    //   }
    //   axios
    //   .post(
    //     `${BaseUrl.baseurl}/email-marketing/user/create-checkout-update-subscription/${userDetails && userDetails.details._id}`,
    //     updateData,
    //     {
    //       headers: {
    //         Authorization: `Bearer ${userDetails && userDetails.token}`,
    //       },

    //     }
    //   )
    //   .then((response) => {
    //     if (response.data.status) {
    //       setLoader(false);
    //       const cbInstance = window.Chargebee.init({
    //         site: "digitalads",
    //         domain: "https://app.coldsender.com",
    //       });

    //       cbInstance.openCheckout({
    //         hostedPage: function () {
    //           return new Promise(function (resolve, reject) {
    //             resolve(response.data.result.hosted_page);
    //           });
    //         },
    //         success: function (hostedPageId) {
    //           toast.success("Payment successfull", {
    //             autoClose: true,
    //             position: "top-right",
    //             duration: 3000,
    //           });
    //           setTimeout(()=>{
    //             callPricingFunction()
    //           },500)
    //         },
    //         error: (error) => {
    //           setTimeout(()=>{
    //             callPricingFunction()
    //           },500)
    //           setShowToast(true);
    //           toast.error("Payment failed", {
    //             autoClose: true,
    //             position: "top-right",
    //             duration: 3000,
    //           });
    //         },
    //       });
    //       // const cbInstance = window.Chargebee.init({
    //       //   site: "digitalads",
    //       //   domain: "https://app.coldsender.com",
    //       // });
    //       // cbInstance.setPortalSession(response.data.details.portal_session);
    //       // const cbPortal = cbInstance.createChargebeePortal()
    //       // console.log('subsciption details',billing)
    //       // const options = {
    //       //   sectionType: "sub_details",
    //       //   params:{
    //       //     subscriptionId:billing.list[0].subscription.id,
    //       //   }
    //       // };
    //       //  cbPortal.open()
    //       // const callbacks = {
    //       //   close: () => {
    //       //     setTimeout(()=>{
    //       //       callPricingFunction()
    //       //     },500)
    //       //     console.log("close called")

    //       //   },
    //       // };
    //       // cbPortal.openSection(options,callbacks);
    //     }
    //     else
    //     {
    //       toast.error(response.data.message, {
    //         autoClose: true,
    //         position: "top-right",
    //         duration: 3000,
    //       });
    //       setLoader(false);
    //       if (response.data.tokenExpire) {
    //         localStorage.removeItem("MailSenderuserDetails");
    //         window.location.reload();
    //       }
    //     }
    //   })
    //   .catch((error) => {
    //     console.error("Error:", error);
    //   });

    // }

    //opening the charge bee portal section open
    // const cbInstance = window.Chargebee.init({
    //   site: "digitalads",
    //   domain: "https://app.coldsender.com",
    // });
    // const cbPortal = cbInstance.createChargebeePortal()

    //  console.log("jabbba",window.Chargebee.getPortalSections())
    // const callbacks = {
    //   close: () => {
    //     console.log("close called")
    //     let config = {
    //       method: 'post',
    //       maxBodyLength: Infinity,
    //       url: `${BaseUrl.baseurl}/email-marketing/user/user-payment/${
    //         userDetails && userDetails.details._id
    //       }`,
    //       headers: {
    //         'Authorization': `Bearear ${userDetails&&userDetails.token}`
    //       }
    //     };

    //     axios.request(config)
    //     .then((response) => {
    //      console.log("results",response.data)
    //     })
    //     .catch((error) => {
    //       console.log(error);
    //     });
    //   },
    // };
    // cbPortal.openSection(options,callbacks);
    //open chargebee whole portal
    //open chargebee whole portal

    //open chargebee whole portal
  };
  function getPayPal(planId) {
    console.log("planId is receiving=====>", planId);
    loadScript({
      clientId:
        "Adn1U9Ufpj79paP_QW0ThYw66JbCXvHT40rYtJtSd4avcChKgPg7_ubGbdSDc-AAVhLc3gWpqQ8xMVWg",
      vault: true,
      intent: "subscription",
    })
      .then((paypal) => {
        paypal
          .Buttons({
            style: {
              shape: "rect",
              color: "gold",
              layout: "vertical",
              label: "subscribe",
            },
            createSubscription: function (data, actions) {
              return actions.subscription.create({
                /* Creates the subscription */
                plan_id: `${planId}`,
              });
            },
            onApprove: function (data, actions) {
              setLoader(false);
              callPricingFunction(selectedPlan, data, "Pay Pal", true);
              // alert(data.subscriptionID); // You can add optional success message for the subscriber here
            },
          })
          .render(`#paypal-button-container-${planId}`);
      })
      .catch((error) => {
        console.error("failed to load the PayPal JS SDK script", error);
      });
    // Renders the PayPal button
  }
  const subscribeButtonRef = useRef(null);

  const priceTypeArr1 = ["INR", "USD", "EUR"];
  const priceTypeArr2 = ["USD", "EUR"];
  const paymentTypeArr = ["One Time", "Pay Pal"];
  const [priceTypeArr, setPriceTypeArr] = useState(priceTypeArr1);
  const [paymentData, setPaymentData] = useState({});
  const [openChoosePaymentModal, setOpenChoosePaymentModal] = useState(false);

  const muiModal = () => {
    return (
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        open={openChoosePaymentModal}
        onClose={() => setOpenChoosePaymentModal(false)}
        closeAfterTransition
        slots={{ backdrop: Backdrop }}
        slotProps={{
          backdrop: {
            timeout: 500,
          },
        }}
      >
        <Fade in={openChoosePaymentModal}>
          <Box sx={style2}>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                paddingBottom: 5,
              }}
            >
              <p
                style={{
                  padding: "4px 0px",
                  fontSize: "24px",
                  color: "#4B4B4B",
                  fontWeight: "700",
                  fontStyle: "normal",
                  lineHeight: "20px",
                  fontFamily: "Source Sans 3",
                }}
              >
                Choose your payment method
              </p>
              <button
                onClick={() => {
                  setOpenChoosePaymentModal(false);
                  setPaymentData({});
                }}
              >
                <HighlightOffIcon />
              </button>
            </div>
            <div
              style={{
                display: "grid",
                gridTemplateColumns: "repeat(1,1fr)",
                gap: 12,
                padding: "10px 0px",
              }}
            >
            
               <div
                style={{
                  // border: "1px solid #DDD",
                  borderRadius: 5,
                  padding: 10,
                  display: "flex",
                  flexDirection: "column",
                }}
              >
                <img
                  src={oneTimepaymentImage}
                  alt="one-time-image"
                  style={{ height: 150, width: "auto" }}
                />
                <p
                  style={{
                    padding: "4px 0px",
                    fontSize: "18px",
                    color: "#1c485f",
                    fontWeight: "700",
                    alignSelf: "flex-start",
                    fontStyle: "normal",
                    lineHeight: "20px",
                    fontFamily: "Source Sans 3",
                  }}
                >
                  One time payment
                </p>
                <p style={{ marginTop: 0 }}>
                  Make a single, upfront payment using your preferred payment
                  method. Perfect for those who prefer to pay for the product or
                  service in full at once without any recurring charges.
                </p>
                <button
                  style={{
                    textTransform: "none",
                    background: "#FF3309",
                    outline: "none",
                    color: "#fff",
                    padding: "10px",
                    fontSize: "14px",
                    fontWeight: "400",
                    borderRadius: "6px",
                    marginTop: 8,
                  }}
                  onClick={() => {
                    paymentData.priceList.map((val) => {
                      if (val.PriceUnit === priceType) {
                        handleSubscribeClick(val.Price, val.PriceUnit, val.id);
                      }
                    });
                    setOpenChoosePaymentModal(false);
                  }}
                >
                  Continue with RazorPay
                </button>
              </div> 
              <div
                style={{
                  // border: "1px solid #DDD",
                  borderRadius: 5,
                  padding: 10,
                  display: "flex",
                  justifyContent: "center",
                  flexDirection: "column",
                }}
              >
                {/* <img
                  src={paypalImage}
                  alt="one-time-image"
                  style={{ height: 150, width: "auto" }}
                /> */}
                {/* <p
                  style={{
                    padding: "4px 0px",
                    fontSize: "18px",
                    color: "#1c485f",
                    fontWeight: "700",
                    alignSelf: "flex-start",
                    fontStyle: "normal",
                    lineHeight: "20px",
                    fontFamily: "Source Sans 3",
                  }}
                >
                  Pay pal
                </p>
                <p style={{ marginTop: 0 }}>
                  Pay securely with PayPal, a trusted and convenient online
                  payment platform used worldwide. With PayPal, you can securely
                  link your bank account, debit card, or credit card to make
                  seamless transactions.
                </p> */}
                <button
                  disabled={priceType === "INR"}
                  style={{
                    textTransform: "none",
                    background: "#FF3309",
                    outline: "none",
                    color: "#fff",
                    padding: "10px 26px",
                    fontSize: "14px",
                    fontWeight: "400",
                    borderRadius: "6px",
                    marginTop: 8,
                  }}
                  onClick={() => {
                    paymentData.priceListPayPal.map((val) => {
                      if (val.PriceUnit === priceType) {
                        getPayPal(val.planId);
                        setPlanId(val.planId);
                        setSelectedPlan(val.id);
                        setOpen(true);
                      }
                    });
                    setOpenChoosePaymentModal(false);
                  }}
                >
                  {priceType === "INR"
                    ? "Unavailable for INR"
                    : "Pay securely with PayPal"}
                </button>
              </div>
            </div>
          </Box>
        </Fade>
      </Modal>
    );
  };

  // this effect hook is called when the payment data is settled
  // useEffect(() => {
  //   if (paymentData) {
  //     paymentData.priceListPayPal?.map((val) => {
  //       if (val.PriceUnit === priceType) {
  //         // getPayPal(val.planId);
  //         setPlanId(val.planId);
  //         setSelectedPlan(val.id);
  //         // setOpen(true);
  //       }
  //     });
  //   }

  // }, [paymentData]);

  return (
    <div style={{ position: "relative", height: "100%", overflow: "auto" }}>
      <Helmet>
        <title>Pricing</title>
        <meta name="description" content="Email campaign user all warmups" />
      </Helmet>
      {/* <button onClick={()=>{
        openCheckout()
      }}>BuyNow</button>    */}
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        open={open}
        onClose={() => {
          setLoader(false);
          setOpen(false);
          setPaymentData({});
          const paypalScript = document.querySelector(
            'script[src*="paypal.com/sdk/js"]'
          );
          if (paypalScript) {
            paypalScript.remove(); // Remove the script element from the DOM
          }
        }}
        closeAfterTransition
        slots={{ backdrop: Backdrop }}
        slotProps={{
          backdrop: {
            timeout: 500,
          },
        }}
      >
        <Fade in={open}>
          <Box sx={style}>
            <div id={`paypal-button-container-${planId}`}></div>
          </Box>
        </Fade>
      </Modal>
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          padding: "8px 0px",
        }}
      >
        <h1
          style={{
            lineHeight: "20px",
            fontFamily: "Source Sans 3",
            fontSize: "34px",
            fontWeight: 700,
            color: "#000",
            fontStyle: "normal",
            alignSelf: "center",
            marginTop: "10px",
          }}
        >
          Simple, transparent pricing
        </h1>
        <p
          style={{
            fontFamily: "Source Sans 3",
            fontSize: "18px",
            color: "727272",
            fontWeight: 400,
            fontStyle: "normal",
            padding: "10px 0px 10px 0px",
            alignSelf: "center",
          }}
        >
          No contracts. No surprise fees.
        </p>
        <div
          style={{
            display: "flex",
            borderRadius: "4px",
            flexGrow: 1,
            justifyContent: "flex-end",
            position: "relative",
            padding: "30px",
          }}
        >
          <div
            style={{
              position: "absolute",
              // right: 150,
              zIndex: 200,
              display: "flex",
              alignItems: "center",
              gap: "16px",
              width: "10%",
            }}
          >
            <FormControl size="medium" sx={{ width: "100%" }}>
              <Select
                displayEmpty
                variant="standard"
                value={priceType}
                disableUnderline
                onChange={(e) => {
                  setPriceType(e.target.value);
                }}
                sx={{
                  outline: "none",
                  backgroundColor: "#FFF",
                  padding: "2px 12px",
                  borderRadius: "4px",
                  fontFamily: "Source Sans 3",
                  fontSize: "12px",
                  fontStyle: "normal",
                  fontWeight: 400,
                  color: "#4B4B4B",
                  border: "1px solid #1c485f",
                }}
                renderValue={(selected) => {
                  if (selected.length === 0) {
                    return (
                      <p
                        style={{
                          fontStyle: "normal",
                          fontSize: "14px",
                          color: "#888888",
                          paddingLeft: "6px",
                        }}
                      >
                        Choose your email
                      </p>
                    );
                  }
                  return selected;
                }}
                inputProps={{ "aria-label": "Without label" }}
                MenuProps={{
                  PaperProps: {
                    style: {
                      maxHeight: 160,
                    },
                  },
                }}
              >
                {priceTypeArr.map((name, index) => (
                  <MenuItem
                    disableRipple
                    disableTouchRipple
                    key={index}
                    value={name}
                    sx={{
                      fontFamily: "Source Sans 3",
                      fontSize: "14px",
                      fontWeight: 400,
                      fontStyle: "normal",
                      color: "#838383",
                      padding: "6px",
                    }}
                  >
                    {name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </div>
        </div>
      </div>
      <ul
        style={{
          display: "flex",
          justifyContent: "center",
          gap: "10px",
          padding: "30px",
          position: "relative",
          zIndex: 60,
          marginTop: 10,
        }}
      >
        {data.map((data, index) => (
          <li
            id={`li-${index}`}
            key={data.id}
            className={
              activePlan === data.id ? "pricing-active" : "pricing-in-active"
            }
            style={{
              position: "relative",
              display: "flex",
              flexDirection: "column",
              justifyContent: "space-between",
              gap: "10px",
              padding: "30px",
              borderRadius: "4px",
              boxShadow: "rgba(0, 0, 0, 0.24) 0px 3px 8px",
              height: activePlan === data.id ? "" : "auto",
              backgroundColor: "#FFF",
            }}
            onClick={() => setActivePlan(data.id)}
          >
            <div>
              <div
                style={{
                  marginBottom: "7px",
                  display: "flex",
                  alignItems: "center",
                  gap: "2px",
                }}
              >
                <h1
                  style={{
                    lineHeight: "40px",
                    fontFamily: "Source Sans 3",
                    fontSize: "24px",
                    fontWeight: 700,
                    fontStyle: "normal",
                    color: "#000",
                  }}
                >
                  {data.priceList.map((val) => {
                    if (val.PriceUnit === priceType) {
                      return `${val.symbol}${val.Price}`;
                    }
                  })}
                </h1>
                <span
                  style={{
                    fontFamily: "Source Sans 3",
                    fontSize: "12px",
                    fontWeight: 400,
                    fontStyle: "normal",
                  }}
                >
                  /
                  {data.Days === 30
                    ? "month"
                    : currentPlan.user?.RedeemCode !== undefined &&
                      currentPlan.user?.RedeemCode?.length > 0 &&
                      data.priceList.some(
                        (item) =>
                          item.Price ===
                          currentPlan?.plan?.SubscriptionDetails.Price
                      )
                    ? "Lifetime"
                    : "year"}
                </span>
              </div>
              {data.priceList.some(
                (item) =>
                  item.Price === currentPlan?.plan?.SubscriptionDetails.Price
              ) ? (
                <div
                  style={{
                    backgroundColor: "#4BC25F",
                    padding: "12px 20px",
                    borderRadius: "6px",
                    marginTop: "17px",
                  }}
                >
                  <p
                    style={{
                      color: "#fff",
                      fontFamily: "Source Sans 3",
                      fontSize: "12px",
                      fontWeight: 700,
                      letterSpacing: "0.8px",
                      fontStyle: "normal",
                      textAlign: "center",
                    }}
                  >
                    Active plan
                  </p>
                </div>
              ) : (
                <>
                  {currentPlan.user?.RedeemCode !== undefined &&
                  currentPlan.user?.RedeemCode.length > 0 ? null : (
                    <button
                      ref={subscribeButtonRef}
                      onClick={() => {
                        setActivePlan(data.id);
                        // setLoader(true);
                        if (index === 0) {
                          // 66e01eadf0581fc3a2248344 for unlimitted
                          callPricingFunction(
                            data.priceList[0].id,
                            {},
                            "Free",
                            false
                          );
                        } else {
                          setOpenChoosePaymentModal(true);
                          setPaymentData(data);
                        }
                      }}
                      type="button"
                      style={{
                        outline: "none",
                        fontFamily: "Source Sans 3",
                        fontSize: "11px",
                        backgroundColor:
                          activeBtn !== "emailMarketing"
                            ? "#3471B8"
                            : "#FF3301",
                        padding: "12px 24px",
                        width: "100%",
                        borderRadius: "6px",
                        color: "#fff",
                        marginTop: "10px",
                      }}
                    >
                      {loader && activePlan === data.id ? (
                        <CircularProgress
                          size={15}
                          style={{
                            color: "white",
                          }}
                        />
                      ) : (
                        <>
                          {currentPlan.length === 0
                            ? "Buy Now"
                            : "Upgrade plan"}
                        </>
                      )}
                    </button>
                  )}
                </>
              )}
              {data.feats.map((pointsData) => (
                <div style={{ marginTop: "10px" }} key={pointsData.id}>
                  <h1
                    key={pointsData.id}
                    style={{
                      lineHeight: "26px",
                      fontFamily: "Source Sans 3",
                      fontSize: "16px",
                      fontWeight: 800,
                      fontStyle: "normal",
                      color: "#000",
                      letterSpacing: "0.7px",
                    }}
                  >
                    {pointsData.title}
                  </h1>
                  {pointsData.points.map((point, index) => (
                    <div
                      key={index}
                      style={{
                        display: "flex",
                        alignItems: "flex-start",
                        gap: "5px",
                        margin: "10px 0px",
                      }}
                    >
                      {activeBtn !== "emailMarketing" ? (
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="16"
                          height="16"
                          viewBox="0 0 20 21"
                          fill="none"
                        >
                          <path
                            d="M10 0.5C4.47715 0.5 0 4.97715 0 10.5C0 16.0228 4.47715 20.5 10 20.5C15.5228 20.5 20 16.0228 20 10.5C19.9936 4.97982 15.5202 0.506429 10 0.5Z"
                            fill="#D1DFE9"
                          />
                          <path
                            d="M15.7722 7.33313L10.068 15.074C9.93197 15.2545 9.72912 15.3727 9.50503 15.4022C9.28094 15.4316 9.05441 15.3698 8.87634 15.2306L4.80301 11.974C4.44356 11.6863 4.38536 11.1617 4.67301 10.8023C4.96066 10.4429 5.48523 10.3846 5.84468 10.6723L9.24134 13.3898L14.4305 6.3473C14.6007 6.09195 14.8974 5.95078 15.2029 5.97983C15.5083 6.00887 15.7731 6.20344 15.8921 6.48627C16.0111 6.76911 15.965 7.09445 15.7722 7.33313Z"
                            fill="#3471B8"
                          />
                        </svg>
                      ) : (
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="16"
                          height="16"
                          viewBox="0 0 20 21"
                          fill="none"
                        >
                          <path
                            d="M10 0.5C4.47715 0.5 0 4.97715 0 10.5C0 16.0228 4.47715 20.5 10 20.5C15.5228 20.5 20 16.0228 20 10.5C19.9936 4.97982 15.5202 0.506429 10 0.5Z"
                            fill="#D1DFE9"
                          />
                          <path
                            d="M15.7722 7.33313L10.068 15.074C9.93197 15.2545 9.72912 15.3727 9.50503 15.4022C9.28094 15.4316 9.05441 15.3698 8.87634 15.2306L4.80301 11.974C4.44356 11.6863 4.38536 11.1617 4.67301 10.8023C4.96066 10.4429 5.48523 10.3846 5.84468 10.6723L9.24134 13.3898L14.4305 6.3473C14.6007 6.09195 14.8974 5.95078 15.2029 5.97983C15.5083 6.00887 15.7731 6.20344 15.8921 6.48627C16.0111 6.76911 15.965 7.09445 15.7722 7.33313Z"
                            fill="#1C485F"
                          />
                        </svg>
                      )}
                      <p
                        style={{
                          color: "#727272",
                          fontFamily: "Source Sans 3",
                          fontWeight: 400,
                          fontStyle: "normal",
                        }}
                        className="twelve-pixel-font"
                      >
                        {point}
                      </p>
                    </div>
                  ))}
                </div>
              ))}
            </div>
            {data.id === 4 && (
              <img
                style={{
                  height: "100px",
                  position: "absolute",
                  top: activePlan === 3 ? -10 : -12,
                  right: 16,
                }}
                src={
                  activeBtn !== "emailMarketing"  
                    ? skyBlueMostPopular
                    : mostPopular
                }
                alt="banner"
              />
            )}
          </li>
        ))}
      </ul>

      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          marginBottom: "24px",
        }}
      >
        <div
          style={{
            minWidth: "800px",
            maxWidth: "900px",
            borderRadius: "4px",
            display: "grid",
            gridTemplateColumns: "repeat(3,1fr)",
            gap: "6px",
            padding: "10px",
            backgroundColor: "#FFF",
            boxShadow:
              "rgba(60, 64, 67, 0.3) 0px 1px 2px 0px, rgba(60, 64, 67, 0.15) 0px 1px 3px 1px",
          }}
        >
          <div>
            <input
              type="text"
              style={{
                backgroundColor: "#D1DFE9",
                outline: "none",
                borderBottom: "2px solid #D1DFE9",
                padding: "10px 6px",
                width: "100%",
                fontSize: "24px",
                fontWeight: 700,
                fontFamily: "Source Sans 3",
                cursor: "default",
                color: "#1C485F",
                borderRadius: "3px",
              }}
              value={"Custom"}
              readOnly={true}
            />
            <div style={{ padding: "6px" }}>
              <p
                style={{
                  fontFamily: "Source Sans 3",
                  fontSize: "16px",
                  fontWeight: 500,
                  fontStyle: "normal",
                  color: "#1C485F",
                }}
              >
                Support
              </p>
              <p
                style={{
                  fontFamily: "Source Sans 3",
                  fontSize: "12px",
                  fontWeight: 400,
                  fontStyle: "normal",
                  color: "#000",
                  marginTop: "0px",
                }}
              >
                Community and developer docs
              </p>
            </div>
          </div>
          <div>
            {firstGrid.map((val) => {
              return (
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "5px",
                    margin: "10px 0px",
                  }}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    viewBox="0 0 20 21"
                    fill="none"
                  >
                    <path
                      d="M10 0.5C4.47715 0.5 0 4.97715 0 10.5C0 16.0228 4.47715 20.5 10 20.5C15.5228 20.5 20 16.0228 20 10.5C19.9936 4.97982 15.5202 0.506429 10 0.5Z"
                      fill="#D1DFE9"
                    />
                    <path
                      d="M15.7722 7.33313L10.068 15.074C9.93197 15.2545 9.72912 15.3727 9.50503 15.4022C9.28094 15.4316 9.05441 15.3698 8.87634 15.2306L4.80301 11.974C4.44356 11.6863 4.38536 11.1617 4.67301 10.8023C4.96066 10.4429 5.48523 10.3846 5.84468 10.6723L9.24134 13.3898L14.4305 6.3473C14.6007 6.09195 14.8974 5.95078 15.2029 5.97983C15.5083 6.00887 15.7731 6.20344 15.8921 6.48627C16.0111 6.76911 15.965 7.09445 15.7722 7.33313Z"
                      fill="#1C485F"
                    />
                  </svg>
                  <p
                    style={{
                      color: "#727272",
                      fontFamily: "Source Sans 3",
                      fontSize: "12px",
                      fontWeight: 400,
                      fontStyle: "normal",
                    }}
                  >
                    {val}
                  </p>
                </div>
              );
            })}
          </div>
          <div>
            {secondGrid.map((val) => {
              return (
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "5px",
                    margin: "10px 0px",
                  }}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    viewBox="0 0 20 21"
                    fill="none"
                  >
                    <path
                      d="M10 0.5C4.47715 0.5 0 4.97715 0 10.5C0 16.0228 4.47715 20.5 10 20.5C15.5228 20.5 20 16.0228 20 10.5C19.9936 4.97982 15.5202 0.506429 10 0.5Z"
                      fill="#D1DFE9"
                    />
                    <path
                      d="M15.7722 7.33313L10.068 15.074C9.93197 15.2545 9.72912 15.3727 9.50503 15.4022C9.28094 15.4316 9.05441 15.3698 8.87634 15.2306L4.80301 11.974C4.44356 11.6863 4.38536 11.1617 4.67301 10.8023C4.96066 10.4429 5.48523 10.3846 5.84468 10.6723L9.24134 13.3898L14.4305 6.3473C14.6007 6.09195 14.8974 5.95078 15.2029 5.97983C15.5083 6.00887 15.7731 6.20344 15.8921 6.48627C16.0111 6.76911 15.965 7.09445 15.7722 7.33313Z"
                      fill="#1C485F"
                    />
                  </svg>
                  <p
                    style={{
                      color: "#727272",
                      fontFamily: "Source Sans 3",
                      fontSize: "12px",
                      fontWeight: 400,
                      fontStyle: "normal",
                    }}
                  >
                    {val}
                  </p>
                </div>
              );
            })}
            <div style={{ display: "flex", gap: "12px" }}>
              <a
                href="mailto:support@coldsender.com"
                target="_blank"
                style={{
                  textDecoration: "none",
                  padding: "8px 16px",
                  backgroundColor: "#D1DFE9",
                  color: "#1C485F",
                  fontFamily: "Source Sans 3",
                  fontStyle: "normal",
                  fontSize: "12px",
                  fontWeight: 400,
                  outline: "none",
                  borderRadius: "4px",
                }}
              >
                Contact us
              </a>
            </div>
          </div>
        </div>
      </div>

      <img
        src={net}
        alt="spider-net"
        style={{ position: "absolute", top: -100, right: 0, zIndex: 10 }}
      />
      {/* <ToastContainer />
      <ToastContainer /> */}
      <ToastContainer />
      {openChoosePaymentModal ? muiModal() : null}
    </div>
  );
};

export default Pricing;
